import { render } from "./accountinghistory.vue?vue&type=template&id=47cb5342"
import script from "./accountinghistory.vue?vue&type=script&lang=js"
export * from "./accountinghistory.vue?vue&type=script&lang=js"

import "./accountinghistory.vue?vue&type=style&index=0&id=47cb5342&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__